<template>
    <div class="financeApplication__form">
        <ValidationProvider :name="radioName"
                            :rules="validationRules"
                            v-slot="{ validate }"
                            slim
        >
            <div :class="classNames">
                <FinanceApplicationRadio v-for="option in options"
                                         :name="option.name"
                                         :radio-value="option.value"
                                         :label="option.label"
                                         :id="option.id"
                                         :key="option.id"
                                         v-model="drivingLicence"
                                         @input="onInput($event, validate)"
                />
            </div>
        </ValidationProvider>
    </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate'
import FinanceApplicationRadio from './FinanceApplicationRadio.vue'
export default {
    components: {
        ValidationProvider,
        FinanceApplicationRadio
    },
    props: {
        initialValues: {
            type: Object,
            default: () => {}
        },
        windowWidth: {
            type: Number,
        }
    },
    data() {
        return {
            drivingLicence: this.initialValues.drivingLicence
        }
    },
    methods: {
        async onInput(value, validate) {
            this.$emit('change', { key: 'drivingLicence', value })

            const { valid } =  await validate(value)
            this.$emit('validate', { key: 'drivingLicence', valid })
        },
    },
    computed: {
        radioName() {
            return 'drivingLicence'
        },
        radioId() {
            return 'drivingLicence'
        },
        options() {
            const name = this.radioName

            return [
                {
                    name,
                    label: 'Full UK',
                    value: 'Full UK',
                    id: this.radioId + 'FullUK'
                },
                {
                    name,
                    label: 'Provisional',
                    value: 'Provisional',
                    id: this.radioId + 'Provisional'
                },
                {
                    name,
                    label: 'CBT',
                    value: 'CBT',
                    id: this.radioId + 'CBT'
                },
                {
                    name,
                    label: 'A2',
                    value: 'A2',
                    id: this.radioId + 'A2'
                },
                {
                    name,
                    label: 'Full A Class',
                    value: 'Full A Class',
                    id: this.radioId + 'FullAClass'
                },
                {
                    name,
                    label: 'European',
                    value: 'European',
                    id: this.radioId + 'European'
                },
                {
                    name,
                    label: 'International',
                    value: 'International',
                    id: this.radioId + 'International'
                },
                {
                    name,
                    label: 'No Licence',
                    value: 'No Licence',
                    id: this.radioId + 'NoLicence'
                }
            ]
        },
        classNames() {
            const className = 'financeApplication__form__fields'

            if (this.windowWidth > 900) {
                return `${className} ${className}--fourWide`
            }

            if (this.windowWidth > 670) {
                return `${className} ${className}--threeWide`
            }

            if (this.windowWidth > 350) {
                return `${className} ${className}--twoWide`
            }

            return `${className} ${className}--oneWide`
        },
        validationRules() {
            return {
                required: true,
                included: this.options.map((o) => o.value)
            }
        },
    },
}
</script>